import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-preview-rotate",
  "use": "icon-preview-rotate-usage",
  "viewBox": "0 0 25 30",
  "content": "<symbol viewBox=\"0 0 25 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-preview-rotate\">\n<rect y=\"12\" width=\"17\" height=\"12\" rx=\"2\" fill=\"currentColor\" />\n<path d=\"M6 5.5L12.75 1.60289L12.75 9.39711L6 5.5Z\" fill=\"currentColor\" />\n<path d=\"M11 5.51354C24 5.01418 24 18.5 24 18.5\" stroke=\"currentColor\" stroke-width=\"1.6\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol